import React from "react";
import {
  ImageBoxFour,
  SecTitle,
  SecSubTitle,
  InfoMedia,
} from "../../components";

const AboutFour = ({ ...restProps }) => (
  <div {...restProps}>
    <div className="container">
      <div className="row flex-row-reverse">
        <div className="col-lg-6 mb-30">
          <ImageBoxFour
            imageOne="images/about/ab-3-1.jpg"
            imageTwo="images/about/ab-3-2.jpg"
          />
        </div>
        <div className="col-lg-6 mb-30 pt-10 pt-lg-0 text-center text-md-start">
          <SecSubTitle>
            <i className="fas fa-bring-forward" /> Empowering Your Digital
            Journey
          </SecSubTitle>
          <SecTitle className="h1 mb-3 pb-3 text-capitalize">
            Ready to Experience Our Best-in-Class IT Services
          </SecTitle>

          <InfoMedia
            className="media-order"
            number="01"
            title="Comprehensive IT Solutions"
            info="We provide end-to-end, scalable technology services tailored to meet your business challenges and accelerate growth."
          />
          <InfoMedia
            className="media-order"
            number="02"
            title="Expert Support & Maintenance"
            info="Our dedicated team ensures your systems are always secure, updated, and optimized for peak performance."
          />
          <InfoMedia
            className="media-order"
            number="03"
            title="Strategic Digital Consulting"
            info="We help you make smarter technology decisions to maximize ROI and streamline operations."
          />
        </div>
      </div>
    </div>
  </div>
);

export default AboutFour;
